import { createContext, useContext, useState } from "react";

export const UserContext = createContext({
  UserID: "",
  Email: "",
  Phone: "",
  FirstName: "",
  MiddleName: "",
  LastName: "",
  SelectedRole: "",
  Roles: [],
  Authorized: false,
  AcceptedEULA: false
});
export const SetUserContext = createContext();

export const useUser = () => {
  return useContext(UserContext);
};

export const useSetUser = () => {
  return useContext(SetUserContext);
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    UserID: "",
    Email: "",
    Phone: "",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    SelectedRole: "",
    Roles: [],
    Authorized: false,
    AcceptedEULA: false
  });

  function updateUser(obj) {
    setUser(obj);
  }

  return (
    <UserContext.Provider value={user}>
      <SetUserContext.Provider value={updateUser}>
        {children}
      </SetUserContext.Provider>
    </UserContext.Provider>
  );
};
